import { FlyerTemplateGroupOption } from "./flyer-template-group-option.interface";
import { FlyerTemplateSummary } from "../../../../../../features/flyer-template/types/flyer-template-summary.interface";

export function createFlyerTemplateGroupOptions(
  templates: FlyerTemplateSummary[]
): FlyerTemplateGroupOption[] {
  let options: FlyerTemplateGroupOption[] = [];

  for (const template of templates) {
    const option = findOptionGroup(template, options);
    if (!option) {
      options = options.concat([
        {
          positions: template.positionCount,
          templates: [template],
        },
      ]);
      continue;
    }

    option.templates = option.templates.concat([template]);
  }

  return sortGroupOptionsByNumberOfPositions(options);
}

function sortGroupOptionsByNumberOfPositions(
  options: FlyerTemplateGroupOption[]
): FlyerTemplateGroupOption[] {
  return options.sort((optionA, optionB) => optionA.positions - optionB.positions);
}

function findOptionGroup(
  template: FlyerTemplateSummary,
  options: FlyerTemplateGroupOption[]
): FlyerTemplateGroupOption | undefined {
  return options.find((option) => option.positions === template.positionCount);
}
